"use strict";

var _defineProperty = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/defineProperty.js");

var _asyncToGenerator = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/asyncToGenerator.js");

var _regeneratorRuntime = require("/usr/src/app/www/node_modules/@babel/runtime/regenerator/index.js");

var _classCallCheck = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/createClass.js");

var _inherits = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/inherits.js");

var _possibleConstructorReturn = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");

var _getPrototypeOf = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/getPrototypeOf.js");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StreamArbitrary = void 0;

var NextArbitrary_1 = require("../../check/arbitrary/definition/NextArbitrary");

var NextValue_1 = require("../../check/arbitrary/definition/NextValue");

var symbols_1 = require("../../check/symbols");

var Stream_1 = require("../../stream/Stream");

var stringify_1 = require("../../utils/stringify");

function prettyPrint(seenValuesStrings) {
  return "Stream(".concat(seenValuesStrings.join(','), "\u2026)");
}

var StreamArbitrary = /*#__PURE__*/function (_NextArbitrary_1$Next) {
  _inherits(StreamArbitrary, _NextArbitrary_1$Next);

  var _super = _createSuper(StreamArbitrary);

  function StreamArbitrary(arb) {
    var _this;

    _classCallCheck(this, StreamArbitrary);

    _this = _super.call(this);
    _this.arb = arb;
    return _this;
  }

  _createClass(StreamArbitrary, [{
    key: "generate",
    value: function generate(mrng, biasFactor) {
      var _this2 = this;

      var appliedBiasFactor = biasFactor !== undefined && mrng.nextInt(1, biasFactor) === 1 ? biasFactor : undefined;

      var enrichedProducer = function enrichedProducer() {
        var _Object$definePropert;

        var seenValues = [];

        var g = /*#__PURE__*/_regeneratorRuntime.mark(function g(arb, clonedMrng) {
          var value;
          return _regeneratorRuntime.wrap(function g$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  if (!true) {
                    _context2.next = 7;
                    break;
                  }

                  value = arb.generate(clonedMrng, appliedBiasFactor).value;
                  seenValues.push(value);
                  _context2.next = 5;
                  return value;

                case 5:
                  _context2.next = 0;
                  break;

                case 7:
                case "end":
                  return _context2.stop();
              }
            }
          }, g);
        });

        var s = new Stream_1.Stream(g(_this2.arb, mrng.clone()));
        return Object.defineProperties(s, (_Object$definePropert = {
          toString: {
            value: function value() {
              return prettyPrint(seenValues.map(stringify_1.stringify));
            }
          }
        }, _defineProperty(_Object$definePropert, stringify_1.toStringMethod, {
          value: function value() {
            return prettyPrint(seenValues.map(stringify_1.stringify));
          }
        }), _defineProperty(_Object$definePropert, stringify_1.asyncToStringMethod, {
          value: function () {
            var _value2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
              return _regeneratorRuntime.wrap(function _callee$(_context3) {
                while (1) {
                  switch (_context3.prev = _context3.next) {
                    case 0:
                      _context3.t0 = prettyPrint;
                      _context3.next = 3;
                      return Promise.all(seenValues.map(stringify_1.asyncStringify));

                    case 3:
                      _context3.t1 = _context3.sent;
                      return _context3.abrupt("return", (0, _context3.t0)(_context3.t1));

                    case 5:
                    case "end":
                      return _context3.stop();
                  }
                }
              }, _callee);
            }));

            function value() {
              return _value2.apply(this, arguments);
            }

            return value;
          }()
        }), _defineProperty(_Object$definePropert, symbols_1.cloneMethod, {
          value: enrichedProducer,
          enumerable: true
        }), _Object$definePropert));
      };

      return new NextValue_1.NextValue(enrichedProducer(), undefined);
    }
  }, {
    key: "canShrinkWithoutContext",
    value: function canShrinkWithoutContext(value) {
      return false;
    }
  }, {
    key: "shrink",
    value: function shrink(_value, _context) {
      return Stream_1.Stream.nil();
    }
  }]);

  return StreamArbitrary;
}(NextArbitrary_1.NextArbitrary);

exports.StreamArbitrary = StreamArbitrary;